import { Controller } from "@hotwired/stimulus"

const INTERACTIVE = "a, button, input, select, textarea, label, summary, [role=menu], [data-disclosure-target]"

// Opens a table row's record when the row itself is clicked. Links, buttons,
// checkboxes and menus inside the row keep their own click; ⌘/Ctrl-click
// opens the record in a new tab, like a link.
export default class extends Controller {
  open(event) {
    if (event.target.closest(INTERACTIVE)) return
    if (window.getSelection()?.toString()) return

    const href = event.currentTarget.dataset.href

    if (event.metaKey || event.ctrlKey) {
      window.open(href, "_blank", "noopener")

      return
    }

    window.Turbo ? window.Turbo.visit(href) : (window.location.href = href)
  }
}
